import TwoFA from '../../components/Auth/TwoFA';
import './styles.scss';

const TwoFAPage = (props: any) => {
    return <TwoFA />
  }
  
  export default TwoFAPage;